import type { NavigationInput } from "../lib/navigation.types.js";
import type { ParamType } from "./params.types";
import { fromStringParams, type ParamsCache } from "./params.utils.js";

/**
 *
 *
 *
 *
 *
 *
 */
const toParams = (url: URL, type: ParamType): [location: URL, params: ParamsCache] => {
  return [url, fromStringParams(url[type].slice(1))];
};

/**
 *
 *
 *
 *
 *
 *
 */
const hasParamFragment = (loc: string, type: ParamType): boolean => {
  return (type === "hash" && loc.includes("#")) || (type === "search" && loc.includes("?"));
};

/**
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const locationToParams = (
  loc: NavigationInput,
  type: ParamType,
  base: Location,
): [location: URL, params: ParamsCache] => {
  /*                                          */
  if (typeof loc !== "string") {
    /*                                                 */
    return toParams(new URL(loc.href), type);
  }

  /*                                          */
  if (loc.startsWith("http")) {
    return toParams(new URL(loc), type);
  }

  /*                                                                  */
  if (hasParamFragment(loc, type)) {
    return toParams(new URL(loc, base.href), type);
  }

  /*                                                                                  */
  const url = new URL(base.href);
  url[type] = loc;
  return toParams(url, type);
};
